// Function to add item to wishlist
function addToWishlist(id, title, handle, image, variantId, variantPrice) {
  let wishlistItems = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlistTextElement = document.querySelector('.wishlist-text');
  
  // Check if item already exists in wishlist
  const existingItem = wishlistItems.find(item => item.id === id);
  if (existingItem) {
    wishlistTextElement.textContent = 'Item already in wishlist';
    document.querySelector('.wishlist-button-container').classList.add('added-animation');
    setTimeout(() => {
      document.querySelector('.wishlist-button-container').classList.remove('added-animation');
    }, 3000); // Duration of the animation
    console.log('Item already in wishlist');
    return;
  }

  // Add new item to wishlist
  wishlistItems.push({ id, title, handle, image, variantId, variantPrice });
  localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
  wishlistTextElement.textContent = 'Item added to wishlist';
  document.querySelector('.wishlist-button-container').classList.add('added-animation');
  setTimeout(() => {
    document.querySelector('.wishlist-button-container').classList.remove('added-animation');
  }, 3000); // Duration of the animation
  console.log('Item added to wishlist');
  updateWishlistCount(); // Update count after adding item
}

// Function to get wishlist items from local storage
function getWishlistItems() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

// Function to render wishlist items
function renderWishlistItems() {
  const wishlistItems = getWishlistItems();
  const wishlistContainer = document.getElementById('wishlist-items');
  wishlistContainer.innerHTML = '';

  if (wishlistItems.length === 0) {
    wishlistContainer.innerHTML = '<p>Your wishlist is empty.</p>';
    return;
  }

  wishlistItems.forEach(item => {
    wishlistContainer.innerHTML += 
      `<div class="wishlist-item">
        <a href="/products/${item.handle}">
          <img src="${item.image}" alt="${item.title}" />
          <h3>${item.title}</h3>
        </a>
        <button onclick="removeFromWishlist('${item.id}')">Remove</button>
      </div>`;
  });
}

// Function to remove item from wishlist
function removeFromWishlist(productId) {
  let wishlistItems = getWishlistItems();
  wishlistItems = wishlistItems.filter(item => item.id !== productId);
  localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
  renderWishlistItems();
  updateWishlistCount(); // Update count after removing item
}

// Function to update wishlist count in the header
function updateWishlistCount() {
  const wishlistItems = getWishlistItems();
  const wishlistCountElement = document.getElementById('wishlist-count');
  console.log(wishlistItems, wishlistCountElement)
  if (wishlistItems.length > 0) {
    wishlistCountElement.textContent = wishlistItems.length;
    wishlistCountElement.style.display = 'flex';
  } else {
    wishlistCountElement.style.display = 'none';
  }
}

// Function to initialize wishlist on page load
function initializeWishlist() {
  updateWishlistCount(); // Ensure count is updated on page load
  renderWishlistItems(); // Render wishlist items
}

// Initialize wishlist on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeWishlist();
});
